module.exports = __webpack_public_path__ + "img/cimb-syariah.2857af6d.png";